<template>
  <!-- 'v-transfer-dom' - from 'vue-transfer-dom' component: append to body (default) -->
  <div class="popup" v-transfer-dom>
    <!-- The Modal -->
    <div v-if="isPopupShown" class="w3-modal" @click.prevent>
      <div class="w3-modal-content">
        <div class="container">
          <div>
            <span class="w3-display-topright close_detail"><i class="sherpa-icon icon-cerrar" @click="popupClose()"></i></span>
            <div class="w3-container">
              <div v-if="title" class="w3-row popup-title">
                {{ title }}
              </div>
              <div class="w3-row popup-content">
                <definition v-if="content"
                  :type="type"
                  :content="content"
                  :id="id"
                  :language="language"
                  :visuals="visuals"
                  :authorization="authorization"
                  :apiparams="apiparams"
                  :showloading="true"
                  :fromPopup="true"
                  @refreshDefinition="refreshDefinition"
                  @popupClose="popupClose"
                />
                <span class="txtPopup" v-else>{{ txtContent }}.</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'popup',
  props: [
    'isPopupShown',
    'title',
    'type',
    'content',
    'txtContent',
    'id',
    'language',
    'authorization',
    'visuals',
    'apiparams'
  ],
  data () {
    return {
    }
  },
  components: {
    Definition: () => import('../definition.vue') // Webpack’s asynchronous import for recursivity components
  },
  methods: {
    popupClose () {
      this.$emit('popupClose')
    },
    refreshDefinition (newRequestObject) {
    }
  }
}
</script>

<style lang="scss">
.popup {
  .txtPopup {
    font-family: Capriola;
    font-size: 16px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 0.83;
    letter-spacing: normal;
    color: white;
  }

  div.definition-title {
    span:first-of-type {
      margin-left: 0;
      font-size: 14px;
      color: #ffffff;
      font-family: Capriola !important;
      display: block;
    }
  }

  #container_form_definition {
    &.modify {
      > #form_definition {
        padding-bottom: 20px;
      }
    }
    .definitionObj {
      padding: 8px 1px 0;
    }
    .definition-wrapper.group {
      padding: 0;

      div.title {
        display: none;
      }
    }
    .headerLangTitle {
      color: #ffffff;
    }
    .label.error_validate {
      color: #E78587;
      margin-top: 9px;
    }
    .group.error_group_validate {
      border: 1px solid #E78587;
    }
  }

  #type_actions {
    position: relative;
    background-color: transparent;
    text-align: center;

    button {
      min-width: 220px;
      background-color: #ff7643;
      margin: 5px;
      float: none;
      width: inherit;

      &.update-and-out {
        display: none;
      }

      span {
        font-family: Capriola;
        font-size: 16px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: center;
        color: white;
      }
    }

    .formErrors,
    .formSaved {
      width: 100%;
      display: block;
      clear: both;
      margin: 10px 10px 0 0;
    }

    .containerFormConfirmDelete {
      margin-right: 0;

      button {
        border-radius: 8px !important;
      }
      .formConfirmDelete {
        border-radius: 8px !important;
        width: 100%;
      }
    }
  }

  .w3-modal {
    display: block !important;
    padding:50px 0;
    cursor: auto;
    z-index: 999999;

    .w3-modal-content {
      background-color: #1c5770;
      top: 50%;
      transform: translateY(-50%);

      .popup-title {
        font-family: Capriola;
        font-size: 18px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 0.83;
        letter-spacing: normal;
        color: white;
        margin: 45px;
      }

      .popup-content {
        margin: 45px;

        .definitionObj {
          .label, p {
            color: #6bceda;
            vertical-align: middle;
            margin-bottom: 2px;

            &.message {
              padding-top: 5px;
            }

            &.error {
              color: #f58686 !important;
            }
          }
        }

        p.italic {
          font-style: italic;
        }

        .input-date,
        .input-checkbox,
        .input-batches {
          i {
            font-size: 2em;
            color: #ff7643;
            margin-left: 10px;
          }

          .time-info {
            margin-top: -4px;
          }

          span, a {
            font-size: 14px;
            font-weight: 600;
            font-style: normal;
            font-stretch: normal;
            line-height: 0.5;
            letter-spacing: normal;
            color: white;
            margin-left: 10px;
          }

          a {
            text-decoration: none;
            color: #ff7643;
          }

          .w3-col {
            width: 20%;
          }
        }

        .info-envio {
          margin-top: 40px !important;

          p {
            font-size: 18px;
            font-weight: 600;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.33;
            letter-spacing: normal;
            color: white;
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
.popup {
  .definition-wrapper.group {
    background-color: transparent;
  }

  .group.definitionObj.item.w3-col {
    position: static !important;
    left: 0 !important;
    top: 0 !important;

    .definition-wrapper.group {
      background-color: transparent !important;
    }
  }

  .item.group {
    position: static !important;
    left: 0 !important;
    top: 0 !important;

    .definition-wrapper.group {
      background-color: transparent !important;

      div.title {
        text-align: left !important;
      }
    }
    .definitionObj {
      padding-right: 10px;
    }
  }

  .mx-datepicker button {
    width: inherit;
  }
  #type_actions {
    position: relative;
    height: 100px;
    background-color: transparent;
    z-index: 0;

    .messages {
      width: 100%;
    }

    .buttons {
      width: 100%;

      button {
        margin-right: 10px;
        padding: 2px 20px 0;
        height: 40px;
        background-color: #fff099;
        border: 1px solid #555;
        width: initial;

        &.delete {
          background-color: #ffec80;
          color: #333;
          text-transform: inherit;
        }

        span {
          font-size: 16px;
          color: #000;
        }
      }

      .containerFormConfirmDelete {
        margin-right: 10px;

        button {
          width: 10%;
          border: 1px solid #555;
          background-color: #fff;
          padding: 2px 0 0;
          min-width: 100px;

          span {
            color: #000;
          }
        }

        .formConfirmDelete {
          display: none;
        }
      }
    }

    button.delete {
      background-color: #ffbd42;
      span {
        color: inherit;
      }
    }
  }

  .tasks {
    .eval {
      .taskEval {
        background: none;
        span {
          font-weight: bolder;
          font-family: Barlow;
          font-size: 14px;
          padding-top: 4px;
        }
      }
    }
  }

  .close_detail {
    top: 25px;
    right: 55px;
    color: #ff7643;
    cursor: pointer;
    z-index: 1000;

    i {
      font-size: 1.8em;
      transition: color 0.2s ease-in;

      &:hover {
        color: #FFBD42;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// node_modules/vue-definition/src/components/popup/index.vue